import Checkbox from "common/Checkbox/Checkbox";
import Text from "common/Typography/Text";
import { typography } from "@shared/common/Themes/typography";
import RequiredFieldMessage from "common/Animations/RequiredFieldMessage";
import { ConnectGroupProps } from "@shared/features/newMarketplace/types";
import styled from "styled-components";
import { LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

const ConnectGroup = ({
  content,
  setIsChecked,
  showError,
  isHighRisk,
}: ConnectGroupProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.MARKETPLACE);

  const getDisplayedText = (text: string) => {
    return (
      <Text
        $size={content ? typography.fontSizes.S : typography.fontSizes.M}
        type={content ? "secondary" : "primary"}
        style={{ position: "relative", top: -4 }}
      >
        {text}
      </Text>
    );
  };

  let options = [
    {
      label: getDisplayedText(t("group_info.modals.join_group_disclaimer")),
      value: 1,
    },
  ];
  if (isHighRisk) {
    options.push({
      label: getDisplayedText(t("group_info.modals.high_risk_disclaimer")),
      value: 2,
    });
  }

  const onChange = (checkedValues: unknown[]) => {
    setIsChecked(checkedValues.length === options.length);
  };

  return (
    <>
      {content && <Text>{content}</Text>}
      <CheckboxGroup
        onChange={onChange}
        options={options}
        style={{ marginTop: content ? 16 : 0, rowGap: 8 }}
      />
      {showError && (
        <RequiredFieldMessage
          requirement={showError}
          errorMessage={t("group_info.modals.unchecked_checkbox_message")}
        />
      )}
    </>
  );
};

export default ConnectGroup;

const CheckboxGroup = styled(Checkbox.Group)`
  &.ant-checkbox-group .ant-checkbox-wrapper .ant-checkbox {
    align-self: flex-start;
  }
`;
